import React, { useEffect, useState } from "react";
import styled from "styled-components";
import down from '../../assets/down_arrow.svg';
import up from '../../assets/up_arrow.svg';
import "react-spring-bottom-sheet/dist/style.css";

const Container = styled.div`
  /* height: 40px; */  
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const List = styled.div`
  /* height: 50px; */
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const Username = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    flex: 1;
`;

const KDA = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`;

const KDAItem = styled.span`
    flex: 1;
    flex-direction: row;
    justify-content: flex-end;
`;

const KDAAttribute = styled.span`
    color: #7A7F9E;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 14px;
    margin-left: 6px;
`;

const Name = styled.span`
    color: #7A7F9E;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    margin-top: 2px;
`;

const Stats = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-top: 24px;
    margin-bottom: 14px;
`;

const Stat = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
`;

const StatCount = styled.span`
    text-align: center;
`;

const StatAttribute = styled.span`
    text-align: center;
    color: #7A7F9E;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    margin-top: 2px;
`;

const Rank = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    color: #7A7F9E;
    margin-right: 10px;
    margin-top: 2px;
`;

export default function ScorecardList(props) {

    const [showDetails, setShowDetails] = useState(false);

  return (    
    <Container>
        <List>
            {props.deathmatch && <Rank>№{props.index + 1}</Rank>}
            <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                <Username>{props.username}</Username>                
                {props.deathmatch && props.name && <Name style={{marginTop: 2}}>{props.score} · {props.name}</Name>}
                {!props.deathmatch && <Name>{props.name}</Name>}
            </div>
            <KDA>
                <KDAItem>
                    <span>{props.kill}</span>
                    <KDAAttribute>K</KDAAttribute>
                </KDAItem>
                <KDAItem>
                    <span>{props.death}</span>
                    <KDAAttribute>D</KDAAttribute>
                </KDAItem>
                <KDAItem>
                    <span>{props.assist}</span>
                    <KDAAttribute>A</KDAAttribute>
                </KDAItem>
                {!props.deathmatch && <KDAItem>
                    <img onClick={() => setShowDetails(!showDetails)} className={'hover'} src={down} />
                </KDAItem>}
            </KDA>
           
        </List>
        {showDetails && <>
            <Stats>
                <Stat>
                    <StatCount>{props.ultimates}</StatCount>
                    <StatAttribute>Ultimate</StatAttribute>
                </Stat>
                <Stat>
                    <StatCount>{props.abilities}</StatCount>
                    <StatAttribute>Abilities</StatAttribute>
                </Stat>
                <Stat>
                    <StatCount>{props.damage}</StatCount>
                    <StatAttribute>Damage</StatAttribute>
                </Stat>
                <Stat>
                    <StatCount>{props.score}</StatCount>
                    <StatAttribute>Score</StatAttribute>
                </Stat>
            </Stats>
        </>}

    </Container>      
  );
}
